import { DaoModel } from '@dynameat/models';

export class GroupIndexingRule extends DaoModel {
  constructor(guid, percentageIncrement, fixedIncrement, isActive, changedGroup,
    referenceGroup, groupsOfProductsPricing, pointOfSale) {
    super(guid);
    this.percentageIncrement = percentageIncrement;
    this.fixedIncrement = fixedIncrement;
    this.isActive = isActive || false;
    this.changedGroup = changedGroup || null;
    this.referenceGroup = referenceGroup || null;
    this.groupsOfProductsPricing = groupsOfProductsPricing || null;
    this.pointOfSale = pointOfSale || null;
  }

  static toInstance(props = {}) {
    return new GroupIndexingRule(
      props.guid,
      props.percentage_increment,
      props.fixed_increment,
      props.is_active,
      props.changed_group,
      props.reference_group,
      props.groups_of_products_pricing,
      props.point_of_sale,
    );
  }

  serialize() {
    return {
      guid: this.guid,
      percentage_increment: this.percentageIncrement,
      fixed_increment: this.fixedIncrement,
      is_active: this.isActive,
      changed_group: this.changedGroup,
      reference_group: this.referenceGroup,
      groups_of_products_pricing: this.groupsOfProductsPricing,
      point_of_sale: this.pointOfSale,
    };
  }
}
